import React from 'react';
import { classNames } from '../../../../utils/style';
import { container } from '../../../../styles/themes';

import { applySize } from './logic';
import {
  ClientBannerElement,
  ClientBannerElementProps,
} from './ClientBannerElement';

export interface ClientBannerProps {
  clientBanner?: ClientBannerElementProps[];
}

export const ClientBanner = ({ clientBanner = [] }: ClientBannerProps) => {
  return (
    <div className={classNames(container, 'lg:w-8/12 mb-48')}>
      <div className="rounded-18 bg-neutral-1 lg:mb-64">
        <div className="flex p-24 md:px-32 lg:px-64 lg:py-32 flex-wrap md:flex-nowrap">
          {clientBanner.map((clientBannerElement, key) => (
            <ClientBannerElement
              label={clientBannerElement.label}
              value={clientBannerElement.value}
              className={classNames(
                'border-neutral-51',
                key !== 0 && 'md:border-l',
                key % 2 === 0 && 'border-r md:border-r-0',
                applySize(clientBanner.length),
              )}
              key={key}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
